import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { LoanFormatIcon } from '../../../../shared/common/GildIcon';
import { useTranslation } from 'react-i18next';

interface Props {
    eaudiobooksAmount: number;
    ebooksAmount: number;
    epressAmount: number;
}

const StAmountBadge = styled.span.attrs({ className: 'marker-badge margin display-inline-flex gild' })``;

const Badge: FC<PropsWithChildren<{ amount: number }>> = ({ children, amount }) => {
    const { t } = useTranslation();

    return (
        <StAmountBadge>
            {children}
            <span>{t('numberFormat.numberWithoutDecimalPoint', { val: amount })}</span>
        </StAmountBadge>
    );
};

export const ProductGroupTypeWithAmounts: FC<Props> = ({ eaudiobooksAmount, ebooksAmount, epressAmount }) => {
    return (
        <>
            <Badge amount={eaudiobooksAmount}>
                <LoanFormatIcon icon="eaudiobook-filled" className="loanformat-icon-small" />
            </Badge>
            <Badge amount={ebooksAmount}>
                <LoanFormatIcon icon="ebook-filled" className="loanformat-icon-small" />
            </Badge>
            <Badge amount={epressAmount}>
                <LoanFormatIcon icon="emagazine-filled" className="loanformat-icon-small" />
            </Badge>
        </>
    );
};
